import { Field } from 'Util/Query';

export class BrandListQuery {
    __construct(){ super.__construct();
        this.options = {};
    }


    getBrandListQuery(options){
        const query = new  Field('brandList');
        if(typeof options === "string"){
            query.addArgument(
                'attribute_code',
                'String!',
                options
            )
        }
        if(typeof options === "object"){
            const  { brandIds, attribute_code } = options;
            if(attribute_code){
                query.addArgument(
                    'attribute_code',
                    'String!',
                    attribute_code
                )
            }

            query.addArgument(
                'brandIds',
                '[Int]',
                brandIds
            )
        }
        query.addFieldList(this._getFields());
        return query;
    }
    _getFields(){
        return [this._getItemsFields(),this._getBrandTypeOptionsField()];
    }

    _getItemsFields(){
        return new Field('items')
            .addFieldList([
                'option_setting_id',
                'filter_code',
                'value',
                'store_id',
                'title',
                'description',
                'image',
                'image_mobile',
                'top_cms_block_id',
                'top_cms_block_content',
                'url_alias',
                'is_featured',
                'meta_title',
                'meta_description',
                'meta_keywords',
                'bottom_cms_block_id',
                'bottom_cms_block_content',
                'slider_position',
                'slider_image',
                'short_description',
                'small_image_alt',
                'small_image',
                'product_page_image',
                'product_page_image_mobile',
                'slider_image_desktop',
                'slider_image_mobile',
                'is_hero',
                'brand_type'
            ]);
    }

    _getBrandTypeOptionsField(){
        return new Field('brand_type_options')
            .addFieldList([
                'value',
                'label'
            ]);
    }

}
export default new BrandListQuery();
